// GAVION booking: lien de réservation de démo et rappels (spéc. 2026-10-15-demo-booking-design). Les pages publiques ont
// leur propre texte (booking/public/copy.ts).
export const bookingFr = {
  settings: {
    title: "Mon calendrier de démo",
    loading: "Chargement de votre calendrier de démo…",
    load_error: "Paramètres indisponibles pour le moment.",
    retry: "Réessayer",
    rep: "Représentant",
    me: "Moi",
    link_title: "Lien de réservation",
    enabled: "Lien actif",
    connect_first: "Connectez Microsoft 365 d'abord",
    connect_link: "Ouvrir les intégrations",
    slug: "Adresse du lien",
    copy: "Copier le lien",
    copied: "Lien copié",
    copy_hint: "Enregistrez et activez le lien pour pouvoir le copier.",
    copy_failed: "Copie impossible : sélectionnez le lien et copiez-le à la main.",
    rep_connect_first: "Ce représentant doit connecter Microsoft 365",
    hours_title: "Heures de disponibilité",
    tz: "Fuseau horaire",
    days: { "1": "Lundi", "2": "Mardi", "3": "Mercredi", "4": "Jeudi", "5": "Vendredi", "6": "Samedi", "7": "Dimanche" },
    closed: "Fermé",
    from: "Début",
    to: "Fin",
    add_short: "Ajouter une plage",
    remove_short: "Retirer",
    add_range: "Ajouter une plage le %{day}",
    remove_range: "Retirer la plage de %{day}",
    limits_title: "Préavis et horizon",
    notice: "Préavis minimum (heures)",
    horizon: "Réservable jusqu'à (jours)",
    reminders_title: "Rappels au prospect",
    r24h: "24 h avant",
    rmorning: "Le matin même à 8 h",
    r1h: "1 h avant",
    custom_minutes: "Rappel personnalisé (minutes avant, facultatif)",
    custom_preview: "Envoyé %{when} la démo",
    custom_line: "Ligne ajoutée au rappel (facultatif, 300 caractères)",
    custom_counter: "%{count} / 300",
    save: "Enregistrer",
    saved: "Calendrier de démo enregistré",
    errors: {
      slug_taken: "Cette adresse est déjà prise.",
      slug_reserved: "Ce lien est réservé, choisissez-en un autre.",
      invalid_slug: "Adresse invalide : lettres minuscules, chiffres et tirets.",
      invalid_hours: "Plages invalides : le début doit précéder la fin, par quarts d'heure, sans chevauchement (4 plages par jour au plus).",
      invalid_notice: "Le préavis doit être entre 0 et 72 heures.",
      invalid_horizon: "L'horizon doit être entre 1 et 60 jours.",
      invalid_reminders: "Rappel personnalisé : entre 15 et 10 080 minutes ; ligne de 300 caractères au plus.",
      invalid_tz: "Fuseau horaire invalide.",
      microsoft_not_connected: "Connectez Microsoft 365 d'abord",
      forbidden: "Accès refusé.",
      not_found: "Représentant introuvable.",
      unavailable: "Enregistrement impossible pour le moment.",
    },
  },
  deal: {
    reminders_on: "Rappels automatiques au prospect",
    heading: "Rappels prévus",
    none: "Aucun rappel prévu.",
    no_invitee: "Pas de rappel : aucun invité sur la réunion",
    demo_note: "Liste des rappels disponible en production",
    recipient: "Destinataire : %{email}",
    sent_to: "à %{email}",
    kinds: { "24h": "24 h avant", morning: "Le matin même (8 h)", "1h": "1 h avant", custom: "Rappel personnalisé" },
    status: { pending: "Prévu", sent: "Envoyé", skipped: "Non envoyé", cancelled: "Annulé", failed: "Échec de l'envoi" },
    reasons: {
      meeting_started: "réunion commencée",
      suppressed: "adresse désabonnée",
      rep_disabled: "rappels désactivés pour ce représentant",
      retry: "nouvel essai prévu",
      graph_bad_request: "Microsoft 365 a refusé le message",
      microsoft_not_connected: "Microsoft 365 n'est pas connecté",
      microsoft_needs_reauth: "Microsoft 365 demande une reconnexion",
      m365_not_configured: "Microsoft 365 n'est pas configuré",
      graph_unavailable: "Microsoft 365 est indisponible",
      needs_review: "envoi à vérifier dans Outlook",
      skipped_other: "non envoyé",
      failed_other: "erreur technique, réessayez plus tard",
    },
    saved_on: "Rappels activés pour cette démo",
    saved_off: "Rappels désactivés pour cette démo",
    errors: {
      forbidden: "Seul le représentant de la démo ou un administrateur peut changer ce réglage.",
      no_active_demo: "Cette démo n'a plus d'événement Outlook.",
      unavailable: "Changement impossible pour le moment.",
    },
  },
};
